import React, { useState, useEffect } from 'react';
import '../pages-styles/members.css';
import { usePageMeta } from '../hooks/usePageMeta';

function Members() {
  usePageMeta(
    'Our Team - Magbity Agency Ltd',
    'Meet the professional team at Magbity Agency Ltd. Expert football agents and consultants dedicated to player representation and club services.'
  );

  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  const apiBaseUrl = process.env.REACT_APP_API_URL || '/api';
  
  // Debug: log the actual API URL being used
  console.log('REACT_APP_API_URL env var:', process.env.REACT_APP_API_URL);
  console.log('Using apiBaseUrl:', apiBaseUrl);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const apiUrl = `${apiBaseUrl}/members/`;
        console.log('Fetching members from:', apiUrl);
        
        const res = await fetch(apiUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });
        
        console.log('Response status:', res.status);
        console.log('Response headers:', res.headers);
        
        // Check if response is actually JSON
        const contentType = res.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
          throw new Error(`Expected JSON but got ${contentType || 'unknown'}`);
        }
        
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        console.log('Fetched members:', data);
        setMembers(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error('Error fetching members:', error);
        setMembers([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMembers();
  }, [apiBaseUrl]);

  return (
    <div className="members-page">
      {/* Hero Section */}
      <section className="members-hero">
        <div className="members-hero-overlay"></div>
        <div className="members-hero-content">
          <h1>Our Team</h1>
          <p>Meet the dedicated professionals behind Magbity Agency Ltd</p>
        </div>
      </section>

      {/* Members Content */}
      <section className="members-content">
        <div className="members-container">
          <h2 className="members-title">Our Professional Team</h2>
          <p className="members-subtitle">
            Our experienced team is committed to providing exceptional service in player representation, club services, and football consultancy.
          </p>

          {loading ? (
            <div className="members-loading">
              <p>Loading team members...</p>
            </div>
          ) : members.length > 0 ? (
            <div className="members-grid">
              {members.map((member) => (
                <div key={member.id} className="member-card">
                  {member.image && (
                    <div className="member-image-wrapper">
                      <img
                        src={member.image}
                        alt={member.name}
                        className="member-image"
                      />
                    </div>
                  )}
                  <div className="member-details">
                    <h3>{member.name}</h3>
                    <p className="member-position">{member.position}</p>
                    {member.bio && (
                      <p className="member-bio">{member.bio}</p>
                    )}
                    <div className="member-contact">
                      {member.email && (
                        <div className="contact-item">
                          <span className="material-icons contact-icon">email</span>
                          <a href={`mailto:${member.email}`} className="contact-link">
                            {member.email}
                          </a>
                        </div>
                      )}
                      {member.phone && (
                        <div className="contact-item">
                          <span className="material-icons contact-icon">phone</span>
                          <a href={`tel:${member.phone}`} className="contact-link">
                            {member.phone}
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="members-empty">
              <p>No team members available at this time.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Members;
